import React from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';

// CompletedMock: extracted UI for the collapsed "completed steps" preview button
const HorizontalCompleteStep: React.FC<{
  showCompleted: boolean;
  completedExpanded: boolean;
  completedIndexes: number[];
  previewCount: number;
  onExpand: () => void;
}> = ({ showCompleted, completedExpanded, completedIndexes, previewCount, onExpand }) => {
  if (!showCompleted || completedExpanded || completedIndexes.length <= previewCount) return null;
  return (
    <React.Fragment key="completed-mock">
      <div className="flex flex-col items-center w-full sm:flex-shrink-0 sm:min-w-[60px] xl:min-w-[80px] sm:max-w-[120px] lg:max-w-[160px] py-4">
        <div className="flex flex-col items-center mb-3">
          <div className="relative flex items-center justify-center mb-2">
            <button
              type="button"
              onClick={onExpand}
              className={`relative flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300
                  w-12 h-12 sm:w-10 sm:h-10
                  bg-white border border-gray-200 text-gray-700
                  rounded-full
                  hover:scale-105
                `}
              aria-label={`แสดงขั้นตอนที่เสร็จแล้วเพิ่มเติม`}
            >
              <div className="flex flex-col items-center text-center">
                <span className="text-xs font-semibold">+{completedIndexes.length - previewCount}</span>
                <span className="text-[10px] text-gray-500">เพิ่มเติม</span>
              </div>
            </button>
          </div>
          <div className="text-center w-full">
            <p className={`text-sm sm:text-xs font-medium leading-tight text-gray-500`} style={{ lineHeight: '1.2rem' }}>
              ขั้นตอนก่อนหน้า
            </p>
          </div>
        </div>
      </div>
      <div className="hidden sm:flex items-start justify-center pt-6 flex-shrink-0">
        <ChevronRight className="text-gray-400" size={18} />
      </div>
      <div className="flex sm:hidden items-center justify-center w-full py-2">
        <ChevronDown className="text-gray-400" size={18} />
      </div>
    </React.Fragment>
  );
};

export default HorizontalCompleteStep;